export const flatHierarchical: <T extends { children?: Array<T> }>(data: T) => Array<T> = (data) => {
  if (!data.children) {
    return [data];
  }

  const recursive = (children) => children.reduce((list, child) => list.concat(child, recursive(child.children || [])), []);

  return recursive(data.children);
};
